(function() {
  'use strict';

  var BATTERY_VARIANTS = {
    'compat-11-15': 58247627276633,
    'compat-16':    58247627309401,
    'orig-11-15':   58247627342169,
    'orig-16':      58247627374937
  };

  function getModelGen(title) {
    if (!title) return null;
    var match = title.match(/iPhone (\d+)/i);
    if (match) return parseInt(match[1]);
    if (/iPhone Air/i.test(title)) return 17;
    return null;
  }

  function isGen16Plus(gen) {
    return gen !== null && gen >= 16;
  }

  function handlePriceDisplay() {
    var priceEl = document.querySelector('.price');
    if (!priceEl) return;

    var priceItem = priceEl.querySelector('.price-item--regular');
    if (!priceItem) return;

    var priceText = priceItem.textContent.trim();
    var priceNum = parseFloat(priceText.replace(/[^0-9.,]/g, '').replace(',', '.'));

    if (priceEl.classList.contains('price--sold-out') || priceNum === 0 || isNaN(priceNum)) {
      priceEl.classList.add('vanuzzo-price-zero');
    } else {
      priceEl.classList.remove('vanuzzo-price-zero');
    }
  }

  function getSelectedBatteryInfo() {
    // Priority 1: variant-level metafield
    var batteryData = null;
    var dataEl = document.getElementById('vanuzzo-battery-data');
    if (dataEl) {
      try { batteryData = JSON.parse(dataEl.textContent); } catch(e) {}
    }

    if (batteryData && batteryData.variants) {
      var currentVariantId = getCurrentVariantId();
      if (currentVariantId && batteryData.variants[currentVariantId]) {
        var val = batteryData.variants[currentVariantId];
        return {
          percentage: 100,
          isOriginal: /originale/i.test(val),
          isCompatible: /compatibile/i.test(val),
          raw: val
        };
      }
    }

    // Priority 2: product-level tag
    if (batteryData && batteryData.productTag) {
      var tagVal = batteryData.productTag.trim();
      if (tagVal) {
        return {
          percentage: 100,
          isOriginal: /originale/i.test(tagVal),
          isCompatible: /compatibile/i.test(tagVal),
          raw: tagVal
        };
      }
    }

    // Priority 3: variant option "Percentuale Batteria"
    var fieldsets = document.querySelectorAll('.product-form__input');
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var legend = fs.querySelector('legend, label, .form__label');
      if (!legend) continue;
      var legendText = legend.textContent.toLowerCase();
      if (legendText.indexOf('batteria') === -1 && legendText.indexOf('battery') === -1) continue;

      var value = '';
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) { value = checked.value; }
      else { var select = fs.querySelector('select'); if (select) value = select.value; }

      if (!value) return { percentage: 0, isOriginal: false, isCompatible: false, raw: '' };
      var numMatch = value.match(/(\d+)\s*%/);
      var percentage = numMatch ? parseInt(numMatch[1]) : 0;
      return { percentage: percentage, isOriginal: /originale/i.test(value), isCompatible: /compatibile/i.test(value), raw: value };
    }

    return { percentage: 0, isOriginal: false, isCompatible: false, raw: '' };
  }

  function getCurrentVariantId() {
    var urlParams = new URLSearchParams(window.location.search);
    var urlVariant = urlParams.get('variant');
    if (urlVariant) return urlVariant;
    var input = document.querySelector('input[name="id"]');
    if (input) return input.value;
    return '';
  }

  function buildBatteryOptionsHtml(batteryInfo, compatPrice, origPrice, compatVariantId, origVariantId) {
    var is100 = batteryInfo.percentage >= 100;

    var html = '<div class="vanuzzo-battery-selector__title">';
    html += '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="6" width="18" height="12" rx="2" ry="2"/><line x1="23" y1="13" x2="23" y2="11"/></svg>';
    html += 'Opzione Batteria</div>';
    html += '<div class="vanuzzo-battery-options">';

    if (is100) {
      var typeLabel = batteryInfo.isOriginal ? 'originale Apple' : (batteryInfo.isCompatible ? 'compatibile certificata' : 'nuova');
      html += '<label class="vanuzzo-battery-option selected vanuzzo-battery-option--locked" data-battery="included">';
      html += '<input type="radio" name="vanuzzo-battery" value="included" checked disabled>';
      html += '<span class="vanuzzo-battery-option__radio"></span>';
      html += '<span class="vanuzzo-battery-option__label">Batteria 100% ' + typeLabel + '<br><span class="vanuzzo-battery-option__desc">Già inclusa in questa variante</span></span>';
      html += '<span class="vanuzzo-battery-option__price">Inclusa</span>';
      html += '</label>';
    } else {
      var percLabel = batteryInfo.percentage > 0 ? batteryInfo.percentage + '%' : '84%';

      html += '<label class="vanuzzo-battery-option selected" data-battery="none">';
      html += '<input type="radio" name="vanuzzo-battery" value="none" checked>';
      html += '<span class="vanuzzo-battery-option__radio"></span>';
      html += '<span class="vanuzzo-battery-option__label">Batteria attuale<br><span class="vanuzzo-battery-option__desc">Almeno ' + percLabel + ' di capacità</span></span>';
      html += '<span class="vanuzzo-battery-option__price">Inclusa</span>';
      html += '</label>';

      html += '<label class="vanuzzo-battery-option" data-battery="compat" data-variant-id="' + compatVariantId + '">';
      html += '<input type="radio" name="vanuzzo-battery" value="compat">';
      html += '<span class="vanuzzo-battery-option__radio"></span>';
      html += '<span class="vanuzzo-battery-option__label">Batteria compatibile nuova<br><span class="vanuzzo-battery-option__desc">100% capacità, compatibile certificata</span></span>';
      html += '<span class="vanuzzo-battery-option__price">+' + compatPrice + '€</span>';
      html += '</label>';

      html += '<label class="vanuzzo-battery-option" data-battery="orig" data-variant-id="' + origVariantId + '">';
      html += '<input type="radio" name="vanuzzo-battery" value="orig">';
      html += '<span class="vanuzzo-battery-option__radio"></span>';
      html += '<span class="vanuzzo-battery-option__label">Batteria originale Apple<br><span class="vanuzzo-battery-option__desc">100% capacità, originale certificata</span></span>';
      html += '<span class="vanuzzo-battery-option__price">+' + origPrice + '€</span>';
      html += '</label>';
    }

    html += '</div>';
    return html;
  }

  function bindBatteryOptionClicks(container) {
    var options = container.querySelectorAll('.vanuzzo-battery-option:not(.vanuzzo-battery-option--locked)');
    options.forEach(function(opt) {
      opt.addEventListener('click', function() {
        container.querySelectorAll('.vanuzzo-battery-option').forEach(function(o) { o.classList.remove('selected'); });
        opt.classList.add('selected');
        opt.querySelector('input').checked = true;
      });
    });
  }

  function updateBatterySelector() {
    var container = document.getElementById('vanuzzo-battery-selector');
    if (!container) {
      createBatterySelector();
      return;
    }

    var title = '';
    var titleEl = document.querySelector('.product__title');
    if (titleEl) title = titleEl.textContent.trim();

    var gen = getModelGen(title);
    var is16Plus = isGen16Plus(gen);
    var compatPrice = is16Plus ? 40 : 30;
    var origPrice = is16Plus ? 100 : 80;
    var compatVariantId = is16Plus ? BATTERY_VARIANTS['compat-16'] : BATTERY_VARIANTS['compat-11-15'];
    var origVariantId = is16Plus ? BATTERY_VARIANTS['orig-16'] : BATTERY_VARIANTS['orig-11-15'];

    var batteryInfo = getSelectedBatteryInfo();
    container.innerHTML = buildBatteryOptionsHtml(batteryInfo, compatPrice, origPrice, compatVariantId, origVariantId);
    bindBatteryOptionClicks(container);
  }

  function createBatterySelector() {
    var title = '';
    var titleEl = document.querySelector('.product__title');
    if (titleEl) title = titleEl.textContent.trim();

    if (!title.toLowerCase().includes('iphone') || !title.toLowerCase().includes('ricondizionato')) return;
    if (document.getElementById('vanuzzo-battery-selector')) return;

    var gen = getModelGen(title);
    var is16Plus = isGen16Plus(gen);
    var compatPrice = is16Plus ? 40 : 30;
    var origPrice = is16Plus ? 100 : 80;
    var compatVariantId = is16Plus ? BATTERY_VARIANTS['compat-16'] : BATTERY_VARIANTS['compat-11-15'];
    var origVariantId = is16Plus ? BATTERY_VARIANTS['orig-16'] : BATTERY_VARIANTS['orig-11-15'];

    var container = document.createElement('div');
    container.id = 'vanuzzo-battery-selector';
    container.className = 'vanuzzo-battery-selector';

    var batteryInfo = getSelectedBatteryInfo();
    container.innerHTML = buildBatteryOptionsHtml(batteryInfo, compatPrice, origPrice, compatVariantId, origVariantId);

    var buyButtons = document.querySelector('.product-form__buttons');
    if (buyButtons) {
      buyButtons.parentNode.insertBefore(container, buyButtons);
    }

    bindBatteryOptionClicks(container);

    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function(e) {
        var selectedBattery = container.querySelector('.vanuzzo-battery-option.selected');
        var batteryValue = selectedBattery ? selectedBattery.dataset.battery : 'none';

        if (batteryValue !== 'none' && batteryValue !== 'included') {
          e.preventDefault();
          var variantId = selectedBattery.dataset.variantId;
          var phoneInput = form.querySelector('input[name="id"]');
          var phoneVariantId = phoneInput ? phoneInput.value : null;

          if (!phoneVariantId) return;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [
                { id: parseInt(phoneVariantId), quantity: 1 },
                { id: parseInt(variantId), quantity: 1 }
              ]
            })
          })
          .then(function(r) { return r.json(); })
          .then(function() {
            window.location.href = '/cart';
          })
          .catch(function(err) {
            console.error('Errore aggiunta carrello:', err);
            form.submit();
          });
        }
      });
    }
  }

  function init() {
    handlePriceDisplay();
    createBatterySelector();

    var variantSelectors = document.querySelectorAll('variant-selects, variant-radios');
    variantSelectors.forEach(function(el) {
      el.addEventListener('change', function() {
        setTimeout(function() {
          handlePriceDisplay();
          updateBatterySelector();
        }, 500);
      });
    });

    var variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      var inputObserver = new MutationObserver(function() {
        setTimeout(function() {
          handlePriceDisplay();
          updateBatterySelector();
        }, 50);
      });
      inputObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

      var lastVal = variantInput.value;
      setInterval(function() {
        if (variantInput.value !== lastVal) {
          lastVal = variantInput.value;
          handlePriceDisplay();
          updateBatterySelector();
        }
      }, 250);
    }

    window.addEventListener('popstate', function() {
      setTimeout(function() {
        handlePriceDisplay();
        updateBatterySelector();
      }, 100);
    });

    var priceContainer = document.querySelector('[id^="price-"]');
    if (priceContainer) {
      var observer = new MutationObserver(function() {
        setTimeout(handlePriceDisplay, 100);
      });
      observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
